import { createSelector } from 'reselect';
import { TEAMS } from '../constants/team.constants';
import { initialState } from '../reducers/team.reducer';
import {ADMIN_PAGE} from "../../containers/AdminPage/constants";
import {fromJS, List} from "immutable";

const selectState = state => state[TEAMS] || initialState;
const selectAdminState = state => state[ADMIN_PAGE] || fromJS({});

export const selectTeams = () => createSelector([selectState, selectAdminState], (state, adminState) => {
    let teams = state.get('data').toList();
    if(!teams?.size) {
        teams = List(adminState.get('teams'));
    }
    // Merge V4 teams (kept in a separate slice — see team.reducer), deduping
    // by id in case the same team appears in both. V3 wins on collision so
    // existing WebSocket-driven fields stay authoritative.
    const v4Teams = state.get('v4Teams') || List();
    if (v4Teams.size) {
        const existingIds = new Set();
        teams.forEach(t => { if (t?.id != null) existingIds.add(String(t.id)); });
        const additions = v4Teams.filter(t => !existingIds.has(String(t.id)));
        teams = teams.concat(additions);
    }
    return teams.sortBy(t => t.accountName + t.name);
});
export const selectSelectedTeam = () => createSelector(selectState, state => state.get('selectedTeam'));
export const selectTeamsFetched = () => createSelector(selectState, state => state.get('fetched'));